module.exports = __webpack_public_path__ + "img/mastercard.195d505d.png";